/**
 * Created by claudio iozzia on 12/07/2017.
 */
import {IComparatorFn, multiSorter} from "../IComparator";
import {FeatureEx} from "./features";
import {isNullOrUndefined} from "util";


export enum FeatureFilterState {
  NO = -1,
  NO_FILTER = 0,
  YES = 1
}


export const SIZE_TOP_FEATURES = 5;
export const SIZE_BOTTOM_FEATURES = 6;

const compareFeatureLevel: IComparatorFn<FeatureEx> = function (a, b): number {
  // x livello crescente : in genere le feature hanno level=Infinity. Le feature Standard (quelle definite dall'applicazione) hanno dei valori numerici < Infinity
  const levA: number = isNullOrUndefined(a.feature.level) ? Number.POSITIVE_INFINITY.valueOf() : a.feature.level; // level must be numeric value or +Infinity
  const levB: number = isNullOrUndefined(b.feature.level) ? Number.POSITIVE_INFINITY.valueOf() : b.feature.level; // level must be numeric value or +Infinity
  return isFinite(levA) ? (isFinite(levB) ? levA - levB : -1) : (isFinite(levB) ? 1 : 0); // ObjectUtil.numericCompare(a.feature.level, b.feature.level);
};

const compareFeatureCommon: IComparatorFn<FeatureEx> = function (a, b): number {
  // x common --> le features comuni a tutti i dispositivi vanno alla fine
  const vA: number = a.isCommon ? 1 : 0;
  const vB: number = b.isCommon ? 1 : 0;
  return vA - vB;  // ObjectUtil.numericCompare(vA, vB);
};

const compareFeatureCount: IComparatorFn<FeatureEx> = function (a, b): number {
  // x count decrescente
  return b.count - a.count; // ObjectUtil.numericCompare(b.feature.count, a.feature.count);
};

const compareFeatureLabel: IComparatorFn<FeatureEx> = function (a, b): number {
  // x Categoria+Label
  const catA: string = a.longLabel;
  const catB: string = b.longLabel;
  return catA.localeCompare(catB);  // ObjectUtil.stringCompare(catA, catB ,true);
};

export const compareFeatureFunctionTop = multiSorter<FeatureEx>([
  compareFeatureLevel,
  compareFeatureCommon,
  compareFeatureCount,
  compareFeatureLabel]);

export const compareFeatureFunctionOthers = multiSorter<FeatureEx>([
  compareFeatureCommon,
  compareFeatureLabel]);
